import styled from 'styled-components';
import IconPause from '../svg/IconPause';
import IconPlay from '../svg/IconPlay';

const AudioButton = ({ isPlaying, onClick }) => {
  return (
    <StyledButton
      type="button"
      onClick={onClick}
      className={isPlaying && 'isPlaying'}
    >
      <span className="a11y-hidden">{isPlaying ? '일시정지' : '재생'}</span>
      {isPlaying ? <IconPause /> : <IconPlay />}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  background: var(--background);
  border: 1px solid var(--grayLv2);
  border-radius: 50%;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.04);

  & > svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  &:not(.isPlaying) svg {
    margin-left: 0.2rem;
  }

  &:hover {
    border: 1px solid var(--surface);

    path,
    rect {
      fill: var(--surface);
    }
  }
`;

export default AudioButton;
